import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';
import InvoicingDetail from './pages/InvoicingDetail';
import InvoicingPage from './pages/InvoicingPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate exact={true} key="invoicing" path="/invoicing" component={InvoicingPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="invoicing-detail" path="/invoicing/:invoiceId/invoicing-detail" component={InvoicingDetail} isLoggedIn={isLoggedIn} />,

    ];
}


// WEBPACK FOOTER //
// ./src/components/invoicing/Invoicing.Routes.tsx